import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '色漫屋',
    url: 'https://baixinsh.com.cn',
    description: '色漫屋是专为漫画爱好者打造的在线漫画平台，汇聚海量漫画资源，涵盖多种题材与风格。',
    sameAs: [
      'https://weibo.com/semanwu',
      'https://space.bilibili.com/semanwu',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@semanwu.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(footerJsonLd)}</script>
      <footer className="bg-background-950 text-background-200">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="text-2xl font-heading text-primary-400 cursor-pointer">
                色漫屋
              </Link>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                海量漫画资源一站畅读，涵盖热血、恋爱、悬疑、搞笑等多种题材，为您提供优质的在线漫画阅读体验。
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="https://weibo.com/semanwu" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="https://space.bilibili.com/semanwu" target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-sm"></i>
                </a>
                <a href="mailto:contact@semanwu.com" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">更多分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-100 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    联系我们
                  </Link>
                </li>
                <li>
                  <a href="mailto:contact@semanwu.com" className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer">
                    contact@semanwu.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; 2026 色漫屋 - 海量漫画资源一站畅读 | 本站所有漫画资源仅供学习交流使用
            </p>
            <div className="flex items-center gap-4 text-xs text-background-500">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              <Link to="/about" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}